import {useParams} from 'react-router'
import {DialogHeader} from './DialogHeader/DialogHeader'
import {DialogDetails} from './DialogDetails/DialogDetails'
import {dialogApi} from '../../../api/dialogApi'
import {LoadingPage} from '../../LoadingPage'
import styles from './DialogWrapper.module.scss'

export const DialogWrapper: React.FC = () => {
  const {dialogId} = useParams<{dialogId: string}>()

  const {isLoading: detailsLoading} = dialogApi.useDialogDetails(dialogId ?? '')
  const {isLoading: flaggedLoading} = dialogApi.useFlaggedResponses(
    dialogId ?? '',
  )

  if (detailsLoading || flaggedLoading) return <LoadingPage />

  return (
    <div className={styles.dialogWrapper}>
      <DialogHeader />
      <DialogDetails />
    </div>
  )
}
